/**
 * Erreurs liées à l'intégration Boond Manager
 */

import { ERROR_CODES } from '@repo/contracts/errors';

import { ErrorConfigWithCallback } from './types';

export const BOOND_ERRORS: Record<string, ErrorConfigWithCallback> = {
    [ERROR_CODES.BOOND_DICTIONARY_SETTINGS_NOT_FOUND]: {
        messageKey: 'unable-to-retrieve-boondmanager-dictionary-settings',
        severity: 'error',
    },
    [ERROR_CODES.BOOND_ENTITY_DOCUMENTS_NOT_FOUND]: {
        messageKey: 'unable-to-retrieve-entity-documents-from-boond',
        severity: 'error',
    },
    [ERROR_CODES.BOOND_ENTITY_TECHNICAL_DATA_NOT_FOUND]: {
        messageKey: 'unable-to-retrieve-entity-technical-data-from-boond',
        severity: 'error',
    },
    [ERROR_CODES.BOOND_OPPORTUNITY_NOT_FOUND]: {
        messageKey: 'unable-to-retrieve-the-opportunity-from-boond',
        severity: 'error',
    },
    [ERROR_CODES.BOOND_OPPORTUNITY_NOT_FOUND_AND_CLEANED]: {
        messageKey: 'the-related-boond-opportunity-has-been-removed',
        severity: 'error',
    },
    [ERROR_CODES.BOOND_BACKUP_ACTION_TYPE_NOT_FOUND]: {
        messageKey: 'err-missing-or-invalid-save-action',
        severity: 'error',
    },
    [ERROR_CODES.BOOND_USER_TOKEN_NOT_FOUND]: {
        messageKey: 'unable-to-retrieve-boondmanager-login-information',
        severity: 'error',
    },
    [ERROR_CODES.BOOND_CANDIDATE_INFORMATION_NOT_FOUND]: {
        messageKey: 'unable-to-retrieve-candidate-information',
        severity: 'error',
    },
    [ERROR_CODES.BOOND_ENTITY_NOT_FOUND]: {
        messageKey: 'unable-to-retrieve-the-entity-from-boond',
        severity: 'error',
    },
};
